import React from 'react';
import { motion } from 'framer-motion';
import { Clock, MapPin } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-290">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-291">
        <div className="absolute inset-0 bg-gradient-to-b from-matambrito-black/80 via-matambrito-black/60 to-matambrito-black z-10" data-id="element-292"></div>
        <img src="https://cdn.magicpatterns.com/uploads/kgDhcY2AxDGiGsF736dPbt/WhatsApp_Image_2026-04-14_at_16.23.43.jpg" alt="El Matambrito Parrilla" className="w-full h-full object-cover object-center" data-id="element-293" />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center w-full pb-32" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-295">
          <span className="inline-block py-1 px-3 rounded-full bg-matambrito-charcoal/80 border border-matambrito-gold/30 text-matambrito-gold text-sm font-medium tracking-wider mb-6 backdrop-blur-sm" data-id="element-296">
            🔥 EL FUEGO ESTÁ PRENDIDO
          </span>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-matambrito-cream mb-6 leading-tight drop-shadow-lg" data-id="element-297">
            Parrilla, patio y momentos únicos en{' '}
            <span className="text-matambrito-gold italic" data-id="element-298">
              Villa Gobernador Gálvez
            </span>
          </h1>

          <p className="text-lg md:text-xl text-matambrito-beige mb-10 max-w-3xl mx-auto leading-relaxed drop-shadow-md" data-id="element-299">
            Viví una experiencia distinta: comida casera hecha con amor, shows
            en vivo, barra de tragos y el espacio perfecto para compartir con
            los que más querés.
          </p>

          <div className="flex justify-center mb-8" data-id="element-300">
            <a href="#espacios" className="bg-transparent border-2 border-matambrito-beige text-matambrito-beige hover:bg-matambrito-beige hover:text-matambrito-black px-10 py-4 rounded-md font-medium text-lg transition-all" data-id="element-301">
              Ver Menú
            </a>
          </div>
        </motion.div>
      </div>

      {/* Bottom Info Bar */}
      <div className="absolute bottom-0 left-0 right-0 z-20 bg-matambrito-black/80 backdrop-blur-md border-t border-white/10 py-4" data-id="element-302">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-matambrito-beige/80" data-id="element-304">
            <div className="flex items-center gap-2" data-id="element-305">
              <Clock className="w-4 h-4 text-matambrito-gold" data-id="element-306" />
              <span data-id="element-307">
                <strong className="text-matambrito-cream" data-id="element-308">Mediodía:</strong> Mar
                a Dom 11–16hs
              </span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-matambrito-beige/30" data-id="element-309"></div>
            <div className="flex items-center gap-2" data-id="element-310">
              <Clock className="w-4 h-4 text-matambrito-gold" data-id="element-311" />
              <span data-id="element-312">
                <strong className="text-matambrito-cream" data-id="element-313">Noche:</strong> Lun a
                Dom 19–01hs
              </span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-matambrito-beige/30" data-id="element-314"></div>
            <div className="flex items-center gap-2" data-id="element-315">
              <MapPin className="w-4 h-4 text-matambrito-red-fire" data-id="element-316" />
              <span data-id="element-317">Av. San Martín 2666, VGG</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}